var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"goods",attrs:{"src":require("../../../../assets/image/live/goods.png")},on:{"click":_vm.showgoods}})
}
var staticRenderFns = []

export { render, staticRenderFns }